export default function NotFound() {
  return <h1>Page not found 404 :(</h1>;
}
